import common from './Common';
/* ********
 * params obj Object or Array
 * return origin params
 * ***********/
class specState {

    constructor(obj){
        if(typeof obj !== 'object'){
            // console.log('解析不成功，参数类型不正确');
            return obj;
        }

        this.data = obj;
    }

    // 解析对象
    resolve(){

        if(this.data instanceof Array){
            this.data.forEach(val=>{
                this.countStock(val);
                this.quickAmount(val);
                this.handleData(val);
            });
            return this.data;
        }

        if(this.data instanceof Object){
            this.countStock(this.data);
            this.quickAmount(this.data);
            this.handleData(this.data);
            return this.data;
        }

    }

    // 获取快速购买数量
    quickAmount(obj){

        if(!obj.quick_amount){
            obj.quick_amount_array = [];
            return; false;
        }

        let strs = obj.quick_amount.split(',');
        let arr = [];

        strs.forEach(val=>{
            arr.push(parseInt(val))
        })

        obj.quick_amount_array = arr;
    }

    // 计算总库存
    countStock(obj){
        let stock = 0;
        obj.spec.forEach(spec=>{
            stock += Number(spec.stock);
        })
        obj.countStock = stock;
    }

    // 获取最大，最小价格，阶梯价格数组
    handleData(obj){

        obj.price_array = [];
        obj.spec.forEach(spec=>{

            // 获取规格阶梯价格数组对象 价格对象
            const { priceArray,priceObject } = this.createStepPrice(spec);
            spec.step_price_array = priceObject;
            spec.price_array = priceArray;

            // 生成spec中所有价格的数组
            if(spec.price){
                obj.price_array.push(parseFloat(spec.price));
            }
            obj.price_array = obj.price_array.concat(priceArray);
        })

        obj.minPrice = Math.min(...obj.price_array);
        obj.maxPrice = Math.max(...obj.price_array);

    }

    // 生成阶梯价格对象,价格数组
    createStepPrice(spec){

        let stepPriceStr = spec.step_price.length < 3 ? [] : spec.step_price.split("|");
        let priceObject = [];
        let priceArray = [];
        let lastForm = 0;

        stepPriceStr.forEach(val=>{

            let p = val.split(",");
                p[0] = Number(p[0]);
                p[1] = parseFloat(p[1]);

                priceObject.push({
                from: lastForm + 1,
                to: p[0],
                price: p[1]
            })
            lastForm = p[0];

            priceArray.push(p[1]);

        })

        return {
            priceArray,
            priceObject
        };
    }
}


const cartHandle = {

    // 根据数量返回价格
    calcPrice(spec,quantity){

        let range = this.stepPriceRange(spec.step_price_array,quantity);
        return range.price || spec.price;
    },

    // 计算满减
    calcSatisfy(spec,quantity){

        // 数量小于1时，放弃计算。
        if(quantity<1) return

        // 当前区间范围
        let currentRange = this.stepPriceRange(spec.step_price_array,quantity);

        // 当前区间不存在，返回空对象
        if(!currentRange.price) return

        // 查询下一阶段区间范围
        let nextStep = this.stepPriceRange(spec.step_price_array,currentRange.to+1);

        // 下一阶段区间不存在，返回空对象
        if(!nextStep.price) return '已享受最大优惠幅度';

        let text = `再买${nextStep.from - quantity}件，每件${nextStep.price.toFixed(2)}元`;

        return text;

    },

    // 获取阶梯价格指定区间
    stepPriceRange(arr,q){
        let obj = {};
        arr.forEach(val=>{
            if( q >= val.from && q <= val.to){
                obj = val;
                return;
            }
        });
        return obj;
    },

    // 购物车数量存储到本地
    saveCart(num){

        const cartInfo = common.storageJson("cartInfo") || {};
        cartInfo.count = num;
        common.storageJson("cartInfo",cartInfo);
    },

}

export {
    specState,
    cartHandle,
}



// WEBPACK FOOTER //
// ./src/assets/js/specState.js